import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { APP_CONFIG, AppConfig } from '@cco-apps/cco-frontend';
import { TenantBaseService } from '@app/shared/services/tenant-base.service';
import { EnabledFeatureFlagsDTO } from '@cco/feature-flags-model';
import { Observable, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService extends TenantBaseService {
  private http = inject(HttpClient);

  constructor() {
    const config = inject<AppConfig>(APP_CONFIG);

    super(config.apiBaseUrl);
  }

  listEnabledFeatureFlags$(): Observable<string[]> {
    return this.tenantBaseUrl$.pipe(
      switchMap(baseUrl => this.http.get<EnabledFeatureFlagsDTO>(`${baseUrl}/feature-flags`)),
      map(dto => dto.enabled),
    );
  }
}
